import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#212731",
            border: "1px solid rgba(240,240,241,0.12)",
            color: "#F0F0F1",
            borderRadius: "0px",
            fontFamily: "Barlow, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
